import { Box, Chip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type PartnerWorkerDetailExperienceProps = {
  data: {
    contractHours?: number;
  };
};

export const PartnerWorkerDetailExperience = (props: PartnerWorkerDetailExperienceProps) => {
  const { t } = useTranslation('partner-screen-specific');
  return (
    <BoxStyled>
      <StyledChip
        label={`${t('partner_worker_detail.contract_hours')}: ${props.data.contractHours ? props.data.contractHours.toString() + ' uur' : '--'}`}
      />
    </BoxStyled>
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.lwPrimaryAccentLight[5],
}));

const BoxStyled = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '8px',
}));
